<form name="customLatlng" ng-submit="$close(custom)" novalidate>
  <div class="modal-header">
    <button type="button" class="close" ng-click="$dismiss()">×</button>
    <h4 class="modal-title">Latitude e Longitude personalizadas</h4>
  </div>
  <div class="modal-body">
    <div class="form-horizontal">
      <div class="form-group">
        <label for="custom-latitude" class="col-xs-4 control-label">Latitude</label>
        <div class="col-xs-8">
          <input
            type="number"
            name="latitude"
            id="custom-latitude"
            ng-model="custom.latitude"
            required
            max="180"
            min="-180"
            class="form-control"
          >
        </div>
      </div>
      <div class="form-group">
        <label for="custom-longitude" class="col-xs-4 control-label">Longitude</label>
        <div class="col-xs-8">
          <input
            type="number"
            name="longitude"
            id="custom-longitude"
            ng-model="custom.longitude"
            required
            max="180"
            min="-180"
            class="form-control"
          >
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-white" ng-click="$dismiss()">Cancelar</button>
    <button type="submit" class="btn btn-success" ng-disabled="customLatlng.$invalid">Salvar</button>
  </div>
</form>
